/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import {
  type AnimatedIllustrativeBaseIconProps,
  AnimatedIllustrativeIcon,
} from "../animated-illustrative-icon";
import animationData from "../assets/json/technical-error-offblack-animated.json";

export const IllustrativeIconTechnicalErrorOffblackAnimated = (props: AnimatedIllustrativeBaseIconProps) => (
  <AnimatedIllustrativeIcon {...props} json={animationData} />
);

IllustrativeIconTechnicalErrorOffblackAnimated.displayName = "IllustrativeIconTechnicalErrorOffblackAnimated";
